var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "confirm-delete" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogOpen,
            "show-close": true,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogOpen = $event
            },
          },
        },
        [
          _c("div", { staticClass: "confirm-delete__title" }, [
            _vm._v("Confirm deletion?"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "confirm-delete__buttons" }, [
            _c("button", { staticClass: "save-btn", on: { click: _vm.del } }, [
              _vm._v("Confirm"),
            ]),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "cancel-btn", on: { click: _vm.cancel } },
              [_vm._v("Cancel")]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }